import React, { useState, useEffect } from 'react';

interface Image {
  name: string;
  url: string;
}

const ImageGallery: React.FC = () => {
  const [images, setImages] = useState<Image[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [fadeIn, setFadeIn] = useState(true);

  useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = async () => {
    try {
      const response = await fetch('/api/files/images');
      const data = await response.json();
      setImages(data.files || []);
    } catch (error) {
      console.error('Error fetching images:', error);
      setImages([]);
    } finally {
      setLoading(false);
    }
  };

  const nextImage = () => {
    if (images.length === 0) return;
    setFadeIn(false);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
      setFadeIn(true);
    }, 200);
  };

  const prevImage = () => {
    if (images.length === 0) return;
    setFadeIn(false);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
      setFadeIn(true);
    }, 200);
  };

  const currentImage = images[currentIndex];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Toolbar */}
      <div style={{
        background: '#c0c0c0',
        borderBottom: '2px solid #808080',
        padding: '2px 4px',
        display: 'flex',
        gap: '8px',
        fontSize: '11px'
      }}>
        <span style={{ padding: '2px 8px' }}><u>F</u>ile</span>
        <span style={{ padding: '2px 8px' }}><u>V</u>iew</span>
        <span style={{ padding: '2px 8px' }}><u>H</u>elp</span>
      </div>

      {/* Image viewer */}
      <div style={{
        flex: 1,
        background: '#000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {loading ? (
          <div style={{ color: '#fff' }}>Loading...</div>
        ) : images.length === 0 ? (
          <div style={{ color: '#fff', textAlign: 'center', padding: '24px' }}>
            <p>No images uploaded yet.</p>
            <p style={{ fontSize: '12px', marginTop: '8px' }}>
              Upload images through the admin panel.
            </p>
          </div>
        ) : (
          <img
            src={currentImage.url || `/assets/images/gallery/${currentImage.name}`}
            alt={currentImage.name}
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain',
              opacity: fadeIn ? 1 : 0,
              transition: 'opacity 0.2s ease-in-out'
            }}
          />
        )}
      </div>

      {/* Controls */}
      <div style={{
        background: '#c0c0c0',
        borderTop: '2px solid #fff',
        padding: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <button onClick={prevImage} disabled={images.length === 0}>
          ◀ Previous
        </button>
        <span style={{ fontSize: '11px' }}>
          {images.length > 0 ? (
            <>
              {currentImage.name} ({currentIndex + 1}/{images.length})
            </>
          ) : (
            'No images'
          )}
        </span>
        <button onClick={nextImage} disabled={images.length === 0}>
          Next ▶
        </button>
      </div>
    </div>
  );
};

export default ImageGallery;
